import { RAISING_AND_ALLOCATING_FUNDS_NAMES } from 'components/BusinessToolForm/Sections/RaisingAndAllocatingFunds/utils/form';

export const RAISING_AND_ALLOCATING_FUNDS_SECTION_INSTRUCTIONS = {
  [RAISING_AND_ALLOCATING_FUNDS_NAMES.INVESTMENT_TOTAL_COST]: {
    name: 'Coste total del proyecto',

    instruction:
      'Realice una estimación detallada del coste total del proyecto. Incluya todas las partidas relevantes, como gastos operativos, inversiones de capital, actividades de marketing, inversiones tecnológicas y recursos humanos.',

    exampleOne: 'El coste total estimado del proyecto de inversión asciende a 5 millones de USD.',

    exampleTwo: 'El coste total del proyecto de expansión de la empresa se estima en 5 millones de USD.',
  },

  [RAISING_AND_ALLOCATING_FUNDS_NAMES.PROJECT_TOTAL_COST]: {
    name: '',
    instruction: '',
    exampleOne: '',
    exampleTwo: '',
  },

  [RAISING_AND_ALLOCATING_FUNDS_NAMES.FUNDING_DESCRIPTION]: {
    name: 'Necesidades de financiación',

    instruction:
      'Calcule el importe de financiación externa necesario restando los recursos propios del coste total de la inversión. Explique cómo se cubrirá esta necesidad de financiación y por qué es esencial para la ejecución del proyecto.',

    exampleOne:
      'La empresa requiere 3 millones de USD de financiación externa, ya que aportará 2 millones de USD con recursos propios. Esta diferencia se cubrirá mediante financiación externa para ejecutar el proyecto de inversión.',

    exampleTwo:
      'La empresa necesita 3,5 millones de USD de financiación externa. Con una aportación propia de 1,5 millones de USD y una inversión total de 5 millones de USD, esta financiación resulta esencial para llevar a cabo el proyecto.',
  },

  [RAISING_AND_ALLOCATING_FUNDS_NAMES.LOAN_TERMS]: {
    name: 'Condiciones del préstamo',

    instruction:
      'Describa las condiciones previstas del préstamo. Incluya información sobre el tipo de interés, el plazo de amortización, las garantías exigidas y cualquier otra condición financiera relevante.',

    exampleOne:
      'La empresa prevé solicitar un préstamo con un tipo de interés del 5 %, un plazo de amortización de cinco años y garantías respaldadas por maquinaria e inmuebles.',

    exampleTwo:
      'Se contempla un préstamo con un tipo de interés fijo del 5 %, un plazo de amortización de cinco años y garantías sobre activos de la empresa. Estas condiciones proporcionan estabilidad financiera y facilitan una planificación eficiente de los pagos.',
  },

  [RAISING_AND_ALLOCATING_FUNDS_NAMES.RAISING_DESCRIPTION]: {
    name: 'Capital que se prevé captar',

    instruction:
      'Indique el importe de inversión que se pretende captar y justifique su necesidad. Explique cómo estos recursos contribuirán al crecimiento, la innovación, la expansión del mercado y el fortalecimiento de la competitividad de la empresa.',

    exampleOne:
      'La empresa prevé captar 1,5 millones de USD para acelerar las actividades de I+D, ampliar su presencia en el mercado y fortalecer su oferta de productos. Esta inversión impulsará el crecimiento, aumentará la cuota de mercado y reforzará el valor de la empresa.',

    exampleTwo:
      'La empresa busca captar 1 millón de USD para financiar actividades de I+D y apoyar su expansión comercial. Esta inversión permitirá acelerar la innovación, responder a la creciente demanda y fortalecer su posición competitiva a largo plazo.',
  },

  [RAISING_AND_ALLOCATING_FUNDS_NAMES.TERMS]: {
    name: 'Condiciones para los inversores',

    instruction:
      'Describa las condiciones ofrecidas a los inversores. Incluya aspectos como la participación accionarial, la política de dividendos, los derechos de voto y las opciones de salida, garantizando su alineación con la valoración de la empresa y su estrategia de crecimiento.',

    exampleOne:
      'La empresa ofrece una participación accionarial del 20 %, una política de distribución de dividendos del 5 % y derechos de voto proporcionales a la participación. Las opciones de salida incluyen la recompra de acciones o una oferta pública inicial (IPO).',

    exampleTwo:
      'La empresa ofrece una participación accionarial del 10 %, derechos de voto, dividendos semestrales y una opción de recompra de acciones transcurridos cinco años. Estas condiciones equilibran la rentabilidad para los inversores con el crecimiento sostenible de la empresa.',
  },

  [RAISING_AND_ALLOCATING_FUNDS_NAMES.ACTIONS_IN_SEARCHING_FOR_FUNDING]: {
    name: 'Estrategia de captación de financiación',

    instruction:
      'Describa las acciones realizadas para obtener financiación. Incluya la identificación de fuentes de financiación, la preparación de materiales para inversores, la participación en eventos del sector, las reuniones con entidades financieras y cualquier otra iniciativa orientada a atraer capital.',

    exampleOne:
      'La empresa ha identificado diversas fuentes de financiación, ha desarrollado una presentación para inversores, ha participado en eventos del sector y mantiene conversaciones con entidades financieras para evaluar distintas alternativas de financiación.',

    exampleTwo:
      'La empresa ha analizado diferentes opciones de financiación, preparado una propuesta de inversión sólida y establecido contactos con potenciales inversores mediante eventos especializados y plataformas profesionales. Paralelamente, negocia con entidades financieras apoyándose en un plan financiero robusto y proyecciones de crecimiento.',
  },

  [RAISING_AND_ALLOCATING_FUNDS_NAMES.ATTRACTING_FINANCING_EXPERIENCE]: {
    name: 'Experiencia en captación de financiación',

    instruction:
      'Describa la experiencia de la empresa en la obtención de financiación. Destaque rondas de inversión, acuerdos con inversores, operaciones de deuda u otros antecedentes relevantes que demuestren su capacidad para estructurar y gestionar procesos de financiación con éxito.',

    exampleOne:
      'La empresa cuenta con experiencia en la obtención de financiación mediante varias rondas de inversión, alianzas estratégicas con inversores y operaciones de deuda estructuradas. Su sólida planificación financiera y capacidad de negociación han respaldado un crecimiento sostenible.',

    exampleTwo:
      'La empresa ha cerrado con éxito diversas operaciones de financiación gracias a una planificación financiera rigurosa, una estrategia de negociación eficaz y soluciones adaptadas a sus objetivos de crecimiento.',
  },

  [RAISING_AND_ALLOCATING_FUNDS_NAMES.UTILIZING_SUPPORT_PROGRAMS]: {
    name: 'Programas de apoyo público',

    instruction:
      'Describa los programas públicos de apoyo empresarial que utiliza o prevé utilizar, como subvenciones, incentivos fiscales o programas de innovación. Explique los beneficios obtenidos y cómo contribuyen al desarrollo del proyecto.',

    exampleOne:
      'La empresa participa en programas públicos de apoyo a la innovación que financian proyectos de I+D y aceleran el desarrollo de nuevos productos y su entrada en el mercado.',

    exampleTwo:
      'La empresa aprovecha subvenciones para actividades de I+D, incentivos fiscales para la innovación y programas públicos de formación que fortalecen su competitividad y capacidad de crecimiento.',
  },
  [RAISING_AND_ALLOCATING_FUNDS_NAMES.FUNDING_DIRECTION_DETAILS]: {
    name: 'Distribución de la financiación',

    instruction:
      'Detalle cómo se distribuirán los recursos financieros entre las principales áreas de inversión, como investigación y desarrollo (I+D), marketing, capital de trabajo, construcción, equipamiento u otras necesidades estratégicas. Especifique el objetivo de cada inversión y el presupuesto asignado.',

    exampleOne:
      'I+D: 1 millón de USD para el desarrollo de tecnologías agrícolas innovadoras y la mejora de productos.\nMarketing: 800.000 USD para campañas de posicionamiento de marca, publicidad y expansión comercial.\nCapital de trabajo: 1,5 millones de USD para garantizar la liquidez operativa.\nConstrucción: 1,2 millones de USD para el desarrollo de instalaciones e infraestructura.\nEquipamiento: 1,5 millones de USD destinados a la adquisición de maquinaria y tecnología avanzada.',

    exampleTwo:
      'I+D: desarrollo de nuevas funcionalidades para la plataforma.\nMarketing: expansión a nuevos mercados.\nCapital de trabajo: garantizar la liquidez operativa.\nConstrucción: apertura de oficinas regionales.\nEquipamiento: modernización de servidores e infraestructura tecnológica.',
  },

  [RAISING_AND_ALLOCATING_FUNDS_NAMES.EXPECTED_FUNDING_PERIOD]: {
    name: 'Calendario de financiación',

    instruction:
      'Defina el calendario previsto para la obtención y utilización de la financiación. Relacione cada fase con los principales hitos del plan de negocio, incluyendo la puesta en marcha, el lanzamiento comercial, el desarrollo del producto, la expansión del mercado y la generación de ingresos.',

    exampleOne:
      'El período de financiación previsto es de tres años e incluye las fases de puesta en marcha, lanzamiento operativo y crecimiento sostenido. Este calendario está alineado con los principales hitos del plan de negocio, como el desarrollo del producto, la penetración en el mercado y la generación de ingresos.',

    exampleTwo:
      'La financiación se ejecutará durante un período de 18 meses, abarcando la puesta en marcha, el lanzamiento y la fase inicial de crecimiento. El cronograma contempla la entrada en el mercado durante los primeros seis meses, el desarrollo del producto a lo largo del primer año y el inicio de la generación de ingresos a partir del mes doce.',
  },

  [RAISING_AND_ALLOCATING_FUNDS_NAMES.FINANCED_PORTION_DESCRIPTION]: {
    name: 'Capacidad de financiación propia',

    instruction:
      'Explique qué porcentaje del coste total del proyecto será financiado con recursos propios. Describa las fuentes de financiación interna —como reservas de efectivo, aportaciones de los socios o recursos propios de la empresa— y justifique cómo esta estructura contribuye a mantener un equilibrio financiero adecuado.',

    exampleOne:
      'La empresa financiará internamente el 40 % del coste total del proyecto mediante reservas de efectivo y aportaciones de capital. Esta estructura mantiene un equilibrio adecuado entre financiación propia y financiación externa, reforzando la estabilidad financiera.',

    exampleTwo:
      'La empresa cubrirá con recursos propios el 30 % de la inversión total, principalmente mediante reservas de efectivo y aportaciones de los socios. Este enfoque permite optimizar la estructura de capital y reducir la dependencia de financiación externa.',
  },

  [RAISING_AND_ALLOCATING_FUNDS_NAMES.BORROW_DESCRIPTION]: {
    name: 'Importe previsto del préstamo',

    instruction:
      'Indique el importe del préstamo previsto y justifique su necesidad. Explique cómo la financiación mediante deuda contribuirá al crecimiento de la empresa, mantendrá la flexibilidad financiera y permitirá aprovechar oportunidades estratégicas de inversión.',

    exampleOne:
      'La empresa prevé solicitar un préstamo de 2,5 millones de USD para cubrir la mayor parte de sus necesidades de financiación. Esta operación permitirá mantener la liquidez, aprovechar oportunidades de crecimiento y sostener una expansión ordenada y sostenible.',

    exampleTwo:
      'La empresa contempla un préstamo de 2,5 millones de USD para financiar su proceso de expansión. Gracias a unas condiciones financieras favorables, esta opción permitirá preservar la flexibilidad financiera y apoyar el crecimiento a largo plazo.',
  },
};
